import type { AppUserRole } from '@api/app-users-api';
import { useAuth } from '@hooks/use-auth';
import { Navigate, Outlet } from 'react-router-dom';

interface RoleGuardProps {
  allowed: AppUserRole[];
}

export default function RoleGuard({ allowed }: RoleGuardProps): React.JSX.Element {
  const { user } = useAuth();

  if (!user || !allowed.includes(user.role)) {
    return <Navigate to="/editions" replace />;
  }

  return <Outlet />;
}
